import { snakeCase } from "lodash";
import { baseUrl } from "../shared/api";

export function tradeDocuments(docType) {
  return `${baseUrl()}/api/v2/${snakeCase(docType)}`;
}

export function PurchaseOrder(docType, id, userId) {
  return `${baseUrl()}/api/v2/users/${userId}/purchase_orders/${id}`;
}

export function PurchaseOrderAttachments(id, userId) {
  return `${baseUrl()}/api/v2/users/${userId}/purchase_orders/${id}/purchase_order_attachments`;
}

export function PurchaseOrderNotifications(id, userId) {
  return `${baseUrl()}/api/v2/users/${userId}/purchase_orders/${id}/fca_notifications?fca_page=trade_document_show&last=true`;
}

export function PurchaseOrderResolveNotifications(id, userId) {
  return `${baseUrl()}/api/v2/users/${userId}/purchase_orders/${id}/resolve_fca_notifications`;
}



// WEBPACK FOOTER //
// ./src/features/trade_documents/apiWrappers.js